<div class="card flex align-items-start" [ngClass]="thumbnail || avatarInitials ? 'gap-4' : 'flex-column'">
	<!-- Initials avatar (person profiles only) — mutually exclusive with the
	     product thumbnail below. -->
	<div *ngIf="avatarInitials && !thumbnail" class="profile-avatar">{{ avatarInitials }}</div>

	<!-- Thumbnail Section (only shown if thumbnail is provided) -->
	<div
		*ngIf="thumbnail"
		class="image-preview-container my-5 p-3"
		(mouseenter)="showPreview = true"
		(mouseleave)="showPreview = false"
	>
		<img [src]="thumbnail || defaultImage" alt="Thumbnail" class="thumbnail" (error)="onImageError($event)" />

		<!-- Full image popup -->
		<div class="full-image-popup" *ngIf="showPreview">
			<h4 class="item-name-header">{{ title | titlecase }}</h4>
			<img [src]="thumbnail || defaultImage" alt="Full Image" (error)="onImageError($event)" />
		</div>
	</div>

	<!-- Content Section -->
	<div class="flex flex-column flex-grow-1 w-full">
		<!-- Header with title and actions -->
		<div class="flex justify-content-between align-items-center mb-2">
			<div class="flex align-items-center gap-2 flex-wrap">
				<h4 class="m-0" *ngIf="!titleHtml">{{ title }}</h4>
				<h4 class="m-0" *ngIf="titleHtml" [innerHTML]="titleHtml"></h4>
				<span *ngIf="idBadge !== null && idBadge !== undefined && idBadge !== ''" class="id-pill">{{
					idBadge
				}}</span>
				<p-tag *ngIf="status" [value]="status" [severity]="statusSeverity"></p-tag>
				<ng-content select="[titleBadge]"></ng-content>
			</div>

			<div class="flex gap-2" *ngIf="additionalButtons.length > 0 || actionItems.length > 0">
				<p-button
					*ngFor="let button of additionalButtons"
					[label]="button.label"
					[icon]="button.icon"
					[disabled]="button.disabled"
					[styleClass]="button.styleClass || ''"
					(onClick)="button.action()"
				/>

				<ng-container *ngIf="actionItems.length > 0">
					<p-menu #menu [model]="actionItems" [popup]="true" />
					<!--
						DOVE-2405 — Actions steps down to outlined only when a standalone button is
						beside it, so the promoted action reads as primary. On the eight profiles
						that pass no additionalButtons (Facility, Rx, PO, Branch, Truck, User,
						Inventory, Asset) this stays false and Actions keeps its solid fill: there it
						IS the primary action and greying it out would be a regression.

						Outlined rather than text: this menu holds Void and Cancel, so it should read
						as a button with a clear hit target, not a link. Matches the Reset/Search
						pairing the search pages already use.
					-->
					<p-button
						label="Actions"
						icon="pi pi-chevron-down"
						[outlined]="additionalButtons.length > 0"
						(onClick)="menu.toggle($event)"
					/>
				</ng-container>
			</div>
		</div>

		<!-- Inline meta row (opt-in): "Label value · Label value" on one line, for
		     headers with few fields. Falls back to the grid below when off. -->
		<div *ngIf="inlineProperties; else propertiesGrid" class="inline-meta">
			<ng-container *ngFor="let property of properties; trackBy: trackByLabel">
				<!-- Forces a new row before this field (see ProfileProperty.breakBefore). -->
				<span class="inline-meta-break" *ngIf="property.breakBefore"></span>
				<span class="inline-meta-item">
					<span class="inline-meta-label">{{ property.label }}</span>
					<a *ngIf="property.routerLink; else inlineValue" [routerLink]="property.routerLink">
						<i *ngIf="property.icon" class="pi" [ngClass]="property.icon"></i>
						{{ property.value || '-' }}
					</a>
					<ng-template #inlineValue>
						<span class="inline-meta-value" *ngIf="!property.htmlValue">{{ property.value || '-' }}</span>
						<span
							class="inline-meta-value"
							*ngIf="property.htmlValue"
							[innerHTML]="property.htmlValue"
						></span>
					</ng-template>
					<p-tag
						*ngIf="property.badge"
						class="ml-2"
						[value]="property.badge.value"
						[severity]="property.badge.severity"
					/>
				</span>
			</ng-container>
		</div>

		<!-- Properties Grid (default) -->
		<ng-template #propertiesGrid>
			<div class="grid">
				<!--allow up to 6 cols of items per row on extra large screens before breaking-->
				<div
					*ngFor="let property of properties; trackBy: trackByLabel"
					[class]="property.colSize || 'col-12 md:col-6 lg:col-4 xl:col-2'"
					class="mb-3"
				>
					<h6 class="font-bold mb-2">{{ property.label }}</h6>
					<div *ngIf="property.routerLink; else htmlOrValue">
						<a [routerLink]="property.routerLink">
							<i *ngIf="property.icon" class="pi" [ngClass]="property.icon"></i>
							{{ property.value || '-' }}
						</a>
					</div>
					<ng-template #htmlOrValue>
						<div *ngIf="!property.htmlValue">{{ property.value || '-' }}</div>
						<div *ngIf="property.htmlValue" [innerHTML]="property.htmlValue"></div>
					</ng-template>
				</div>
			</div>
		</ng-template>

		<!-- DOVE-2342 — optional footer slot for content that isn't a plain
		     attribute (e.g. Purchase Order's read-only comments), rendered under
		     the attributes. Empty for profiles that don't project into it. -->
		<ng-content select="[profileFooter]"></ng-content>
	</div>
</div>
